export const preserveStudioMemberOrder = (previous: readonly string[], selected: readonly string[]): string[] => {
  const remaining = new Set(selected);
  const existing = new Set(previous);
  return [...previous.filter((member) => remaining.has(member)), ...selected.filter((member) => !existing.has(member))];
};
